var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoReplayDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    fill: "#7a7d7a",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100,40V0L50,50l50,50V60c33.2,0,60,26.9,60,60s-26.9,60-60,60s-60-26.9-60-60H20c0,44.2,35.8,80,80,80s80-35.8,80-80 S144.2,40,100,40z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoReplayDisabled);
export default __webpack_public_path__ + "static/media/ico-replayDisabled.5b044e764c0a26d3f29142cedf8d8fcb.svg";
export { ForwardRef as ReactComponent };